import React from 'react';
import { Hero } from '../components/Hero';
import { ErrorSection } from '../components/ErrorSection';
import { TargetAudience } from '../components/TargetAudience';
import { PillarCards } from '../components/PillarCards';
import { IncludesSection } from '../components/IncludesSection';
import { LearningSection } from '../components/LearningSection';
import { InsideSection } from '../components/InsideSection';
import { ResultsSection } from '../components/ResultsSection';
import { FAQ } from '../components/FAQ';
import { TrustSection } from '../components/TrustSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { LegalFooter } from '../components/LegalFooter';
export function LandingPage() {
  return <main className="w-full min-h-screen bg-bg-primary" data-id="element-334">
      <Hero data-id="element-335" />
      <ErrorSection data-id="element-336" />
      <TargetAudience data-id="element-337" />
      <PillarCards data-id="element-338" />
      <IncludesSection data-id="element-339" />
      <LearningSection data-id="element-340" />
      <InsideSection data-id="element-341" />
      <ResultsSection data-id="element-342" />
      <FAQ data-id="element-343" />
      <TrustSection data-id="element-344" />
      <FinalCTA data-id="element-345" />
      <Footer data-id="element-346" />
      <LegalFooter data-id="element-347" />
    </main>;
}